<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <v-avatar
        size="30px"
        color="#f4f5fa"
        class="brand-logo d-flex align-center me-3"
      >
        <v-img
          alt="logo"
          contain
          eager
          :src="appLogo"
        />
      </v-avatar>

      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- <img
              height="362"
              class="auth-mask-bg"
              :src="require(`@/assets/images/misc/mask-v2-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
            /> -->

            <!-- <v-img
              height="226"
              width="300"
              class="auth-tree"
              src="@/assets/images/misc/tree-4.png"
            ></v-img> -->

            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                class="auth-3d-group"
                contain
                max-width="100%"
                height="510"
                :src="require(`@/assets/images/logos/TECH_Horizontal_${$vuetify.theme.dark ? 'White' : 'Color'}.png`)"
              />
            </div>
          </div>
        </v-col>

        <v-col
          lg="4"
          class="d-flex align-center auth-bg pa-10 pb-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <v-card-text>
                  <p class="text-2xl font-weight-semibold text--primary mb-2">
                    Esqueceu a senha? 🔒
                  </p>

                  <p class="mb-2">
                    Digite seu e-mail e enviaremos instruções para redefinir sua senha
                  </p>
                </v-card-text>

                <v-card-text>
                  <v-form
                    ref="formRef"
                    @submit.prevent="handleSubmitBtnClick"
                  >
                    <v-text-field
                      v-model="request.email"
                      class="mb-4"
                      label="Email"
                      outlined
                      hide-details="auto"
                      placeholder="joao@exemplo.com"
                      :rules="[validators.required, validators.emailValidator]"
                    />

                    <v-btn
                      block
                      type="submit"
                      color="primary"
                    >
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="secundary"
                      />

                      <span v-else>Enviar código</span>
                    </v-btn>
                  </v-form>
                </v-card-text>

                <v-card-actions class="d-flex justify-center align-center">
                  <router-link
                    :to="{ name: 'auth-login' }"
                    class="d-flex align-center text-sm"
                  >
                    <v-icon
                      size="24"
                      color="primary"
                    >
                      {{ icons.mdiChevronLeft }}
                    </v-icon>

                    <span>Voltar ao login</span>
                  </router-link>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';
</style>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { mdiChevronLeft } from '@mdi/js'
import { emailValidator, required } from '@core/utils/validation'
import themeConfig from '@themeConfig'
import router from '@/router'
import AuthService from '@/services/modules/AuthService'
import useForm from '@/composables/useForm'

export default {
  setup() {
    const { formRef, loading, FORM_ERROR, validateForm } = useForm()
    const request = ref({ email: '' })

    function goToResetarSenha() {
      router.push({ name: 'auth-resetar-senha',
        query: { email: request.value.email } })
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return

      if (!validateForm()) {
        Vue.$toast.warning(FORM_ERROR)
      }

      try {
        loading.value = true

        await AuthService.enviarEmailResetSenha(request.value)

        goToResetarSenha()
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      request,

      handleSubmitBtnClick,

      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      icons: {
        mdiChevronLeft,
      },

      validators: {
        required,
        emailValidator,
      },
    }
  },
}
</script>
